<template>
    <div v-if="localModalValue" style="z-index: 100;">
        <div v-if="defaultShowChanges" class="w-full bg-additional-text flex justify-center items-center"
             style="z-index: 100;"
             :style="{'height': `${-default_height}rem`}">
            <p v-if="defaultShowChanges" class="text-base-lg text-white">{{defaultModalText}}</p>
        </div>
        <div v-if="defaultShowCookieChanges" class="w-full bg-additional-text flex justify-center items-center">
            <div class="w-full h-full relative flex items-center text-center lg:text-left xl:text-left p-5">
                <img src="@/assets/SVG/white-cross.svg" class="absolute text-white pin-t pin-r mr-2 mt-2 cursor-pointer text-xl z-50 h-4" @click="closeCookieModal">
                <div class="w-full h-full flex flex-col lg:flex-row xl:flex-row">
                    <div class="w-full lg:w-2/3 xl:w-2/3 pt-3 lg:pt-0 xl:pt-0">
                        <p v-if="defaultShowCookieChanges" class="text-sm lg:text-base-lg xl:text-base-lg text-white">
                            Мы используем cookies для быстрой и удобной работы сайта. Продолжая пользоваться сайтом, вы принимаете
                            <a href="/confidence.pdf" target="_blank"
                               class="text-white text-sm lg:text-base-lg xl:text-base-lg underline hover:no-underline cursor-pointer ">
                                Политику конфиденциальности
                            </a>, защиты персональных данных и использования файлов cookie.
                        </p>
                    </div>
                    <div class="w-full lg:w-1/3 xl:w-1/3 flex justify-end pt-4 lg:pt-0 xl:pt-0">
                        <button @click="closeCookieModal"
                                class="rounded-lg bg-additional-text border-white border flex text-center items-center justify-center mr-10"
                                style="width: 200px; height: 40px">
                            <p class="text-white text-sm lg:text-base-lg xl:text-base-lg">Принять</p>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'changes-saved',

  data() {
    return {
      default_height: -3.125,
      localModalValue: false,
      loaded: false,
    };
  },
  created() {
    this.transformHeight(0, 1);
    this.localModalValue = this.defaultShowChanges || this.defaultShowCookieChanges;
  },
  watch: {
    defaultShowChanges() {
      this.localModalValue = this.defaultShowChanges;
    },
    defaultShowCookieChanges() {
      this.localModalValue = this.defaultShowCookieChanges;
    },
    localModalValue() {
      if (this.localModalValue === true) {
        this.transformHeight(0, -1);
      }
      if (this.localModalValue === false) {
        this.transformHeight(0, 1);
      }
    },
  },
  computed: {
    ...mapState({
      formName: state => state.form.formName,
      formEmail: state => state.form.formEmail,
      defaultShowChanges: state => state.changes.showModal,
      defaultModalText: state => state.changes.modalText,
      defaultShowCookieChanges: state => state.cookieNotic.showCookieModal,
    }),
  },
  methods: {
    closeCookieModal() {
      this.selectShowCookieModal(false);
      this.selectIsShowed(true);
    },
    ...mapActions(['selectShowModal', 'selectShowCookieModal', 'selectIsShowed']),
    transformHeight(counter, direction) {
      if (counter < 20) {
        setTimeout(() => {
          if (direction < 0) { this.default_height -= 0.15625; }
          if (direction > 0) { this.default_height += 0.15625; }
          counter++;
          this.transformHeight(counter, direction);
        }, 0.2);
      }
      if (counter === 20 && direction < 0) {
        setTimeout(() => { this.selectShowModal(false); }, 5000);
      }
    },
  },
};
</script>

<style scoped>

</style>
